<template>
    <div class="row mb-3">
        <div class="col-3">
            <label :for="forInput">
                {{label}}
            </label>
        </div>
        <div class="col-9">
            <slot>

            </slot>
        </div>
    </div>
</template>

<script>
export default {
    name: 'journey-conection-property-base',
    props: {
        label: {
            type: String,
            default : ''
        },
        forInput: {
            type: String,
            default: ''
        }
    }
};
</script>

<style lang="scss" scoped>

</style>